import React from "react";
import "./Slider.css";

interface SliderProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

const Slider: React.FC<SliderProps> = ({ checked, onChange, disabled = false }) => {
  return (
    <label className={`slider-container ${disabled ? "is-disabled" : ""}`}>
      <input type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
      <span className="slider-track">
        <span className="slider-thumb"></span>
      </span>
    </label>
  );
};

export default Slider;
